import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import { Form, Alert, Col, Row } from 'react-bootstrap';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { Card, Checkbox } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import DropdownKelasKapital from '../masterDropDown/DropdownKelasKapital';
// import DropdownKelasParalel from '../masterDropDown/DropdownKelasParalel';
import DropdownMapel from '../masterDropDown/DropdownMapel';
import DropdownTematik from '../masterDropDown/DropdownTematik';

class Vc extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            alertShow: false,
            kelas: [],
            mapel: [],
            tematik: [],
            idJadwal: '',
            idMapel: '',
            idTematik: '',
            kelasParalel: [],
            isOpenModalAddEdit: false,
            titleModal: 'Tambah VideoConf',
            judulVc: '',
            linkVideoConf: 'https://www.youtube.com/watch?v=aeoVnT1ITr8',
            jadwal: {},
            selectedKelas: '',
            selectedKelasParalel: [],
            resMessage: '',
            tglMulai: '',
            jadwalVidConf: [],
            selectedProfil: {},
        };

        this.handleCbxOnChange = this.handleCbxOnChange.bind(this);
    }

    async componentDidMount() {
        console.clear();
        console.info('componentDidMount');

        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.getListJadwalVidConf();
            this.getKelas();
        }

        this.setState({
            isFetching: false
        });
    }

    getListJadwalVidConf = async() => {
        console.clear();
        console.info('getJadwalVidConf');

        this.setState({
            isFetching: true
        });

        const response = await accountManagement.get(CONFIG.VC_JADWAL_LIST)
        .catch(function(error) {
            console.error('getJadwalVidConf Error', error);
        });
        console.info('Response getJadwalVidConf', response);

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    jadwalVidConf: response.data.data.listVcGuru
                })
            }
            else {
                this.setState({
                    resMessage: response.data.errorSchema.errorMessage
                })
            }
        } 

        this.setState({
            isFetching: false
        })
    }

    getDetailJadwalVidConf = async(idJadwalProfil) => {
        console.clear();
        console.info('getDetailJadwalVidConf');

        this.setState({
            isFetching: true,
            isOpenModalAddEdit: true,
        });

        const response = await accountManagement.get(CONFIG.VC_JADWAL_DETAIL + idJadwalProfil)
        .catch(function(error) {
            console.error('getDetailJadwalVidConf Error', error);
        });
        console.groupCollapsed('getDetailJadwalVidConf');
        console.info('Response getDetailJadwalVidConf', response);
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    idJadwal: response.data.data.dataJadwal.idJadwal,
                    jadwal: response.data.data.dataJadwal,
                    judulVc: response.data.data.dataJadwal.namaJadwal,
                    selectedKelas: response.data.data.dataJadwal.idKelas,
                    idMapel: response.data.data.dataJadwal.idMapel,
                })

                this.fetchKelasParalel(this.state.selectedKelas);
                this.getMapel(this.state.selectedKelas);
                this.getTematik(this.state.selectedKelas);

                // selectedKelasParalel
                let isTrueKelasParalel = [];
                response.data.data.kelasTerpilih.map((dataKP, indexKP) => {
                    if(dataKP.isTerpilih === true) {
                        // console.info('dataKP', dataKP.idKelasParalel);
                        isTrueKelasParalel.push(dataKP.idKelasParalel);

                        this.setState({
                            selectedKelasParalel: isTrueKelasParalel,
                        });
                    }
                });
                // console.info('Cek isTrueKelasParalel', isTrueKelasParalel);
                // console.info('Cek State selectedKelasParalel', this.state.selectedKelasParalel);
            }
            else {
                this.setState({
                    resMessage: response.data.errorSchema.errorMessage
                })
            }
        } 

        this.setState({
            isFetching: false
        })
    }

    handleDelete = async(idProfil) => {
        this.setState({
            isFetching: true,
        });

        const response = await accountManagement.get(CONFIG.VC_JADWAL_DELETE + idProfil)
        .catch(function(error) {
            console.error('handleDelete Error', error);
        });
        
        if(response.data.data.message === 'Berhasil hapus') {
            this.getListJadwalVidConf();
        }

        this.setState({
            openDialog: false,
            isFetching: false
        });
    }

    getKelas = async() => {
        console.clear();
        console.info('getKelas');

        this.setState({
            isFetching: true
        })

        const res = await accountManagement.get(CONFIG.GET_KELAS_BY_GURU + this.props.account.idGuru)
        .catch(function(error) {
            console.error('Error getKelas', error);
        })
        console.info('Result getKelas', res);

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: res.data.data
                })
            }
            else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    getMapel = async(id) => {
        console.clear();
        console.info('getMapel', id);

        this.setState({
            isFetching: true
        });

        const resMapel = await accountManagement.get(CONFIG.GURU_GET_MAPEL_BY_KELAS, {
            params: {
                ['idKelas']: id,
                ['idGuru']: this.props.account.idGuru
            }
        }).catch(function(error) {
            console.error('Error getMapel', error);
        })
        
        if(resMapel) {
            if(resMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    mapel: resMapel.data.data
                    // profil: {...this.state.profil, ['idKelas']: id}
                })
            }

            this.setState({
                isFetching: false
            });
        }
    }

    getTematik = async(id) => {
        console.clear();
        console.info('getTematik', id);

        this.setState({
            isFetching: true
        });

        const res = await accountManagement.get(CONFIG.MAPEL_MANAGEMENT_FETCH_TEMATIK_BY_ID_KELAS, {
            params: {idKelas: id}
        }).catch(function(error) {
            console.error('Error getTematik', error);
        })

        if(res) {
            if(res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    tematik: res.data.data
                })
            }
            this.setState({
                isFetching: false
            });
        }
    }

    judulOnChange = async (e) => {
        console.clear();
        console.log('judulOnChange', this.state.selectedKelasParalel);

        this.setState({
            judulVc: e.target.value
        });
    }

    handleOnChangeKelas = async (idKelas) => {
        console.clear();
        this.setState({            
            selectedKelas: idKelas.target.value
        });

        this.fetchKelasParalel(idKelas.target.value);
        this.getMapel(idKelas.target.value);
        this.getTematik(idKelas.target.value);
    }

    fetchKelasParalel = async (idKelas) => {
        this.setState({
            isLoading: true
        });
        const response = await accountManagement.get(CONFIG.GURU_GET_KELASPARALEL_BY_KELAS + idKelas )
        .catch (function(error) {
            console.error('fetchKelasParalel', error);
        })

        console.log(response);

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelasParalel: response.data.data
                })
            }
            
            this.setState({
                isLoading: false
            });
        }
    }

    handleCbxOnChange(event) {
        console.clear();
        console.info('handleCbxOnChange', event);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(value) {
            this.setState(prevState => ({ selectedKelasParalel: prevState.selectedKelasParalel.concat(name) }));
        }
        else {
            var array = [...this.state.selectedKelasParalel]; // make a separate copy of the array
            var index = array.indexOf(name);

            if (index !== -1) {
                array.splice(index, 1);
                this.setState({selectedKelasParalel: array});
            }
        }
    }

    renderKp() {
        console.clear();
        console.groupCollapsed('renderKp Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();
        
        var n = 1;
        if(!__.isEmpty(this.state.kelasParalel)) {
            return this.state.kelasParalel.map((val, j) => {
                if(!__.isEmpty(this.state.selectedKelasParalel)) {
                    const found = this.state.selectedKelasParalel.find((e) => parseInt(e) === val.idKelasParalel);

                    return (
                        <Card>
                            <Row style={{ margin: '3px' }}>
                                <Col sm={1}>{n++}</Col>
                                <Col sm={10}>{val.namaKelasParalel}</Col>
                                <Col sm={1}>
                                    <Checkbox name={val.idKelasParalel} onChange={this.handleCbxOnChange} checked={found !== undefined ? "true" : ""}/>
                                </Col>
                            </Row>
                        </Card>
                    )
                }
                else {
                    return (
                        <Card key={j}>
                            <Row style={{ margin: '3px' }}>
                                <Col sm={1}>{n++}</Col>
                                <Col sm={10}>{val.namaKelasParalel}</Col>
                                <Col sm={1}>
                                    <Checkbox name={val.idKelasParalel} onChange={this.handleCbxOnChange} />
                                </Col>
                            </Row>
                        </Card>
                    )
                }
            })
        }
    }

    changeJadwalMulai = (date) => {
        console.clear();
        console.info('changeJadwalMulai', date);
        this.setState(prevState => ({     
            jadwal: {...prevState.jadwal,jadwalMulai: date}
        }))
        this.setState({tglMulai : date})
    }

    changeJadwalSelesai = (date) => {
        console.clear();
        console.info('changeJadwalSelesai', date);
        this.setState(prevState => ({     
            jadwal: {...prevState.jadwal,jadwalSelesai: date}
        }))
    }

    handleChangeMapel = (e) => {
        console.clear();
        console.info('handleChangeMapel', e);
        this.setState({
            idMapel: e.target.value
        })
    }

    handleChangeTematik = (e) => {
        console.clear();
        console.info('handleChangeTematik', e);
        this.setState({
            idTematik: e.target.value
        })
    }

    handleSubmit =  async (e) => {
        console.clear();
        e.preventDefault();

        this.setState({
            isFetching: true
        });

        const formdata = new FormData(e.target);
        /*
        ** convert FormData to json object
        ** SOURCE: https://stackoverflow.com/a/46774073
        */
        const data = {}
        formdata.forEach(function(value, prop) {
            data[prop] = value
        });
        
        /*
        "idKelas": 19,
        "idMapel": 85,
        "idKurikulum": 3,
        "namaProfil": "kirim",
        "namaJadwal": "jadwal nama",
        "jadwalMulai": "03-08-2020 10:24",
        "jadwalSelesai": "15-09-2020 10:24",
        "idKelasParalel": [1, 2],
        "linkVideoConf": "https://www.youtube.com/watch?v=aeoVnT1ITr8"
        */


        const dataSend = {
            ['idProfil']: this.state.idProfil,
            ['idJadwal']: this.state.idJadwal,
            ['idKelas']: this.state.selectedKelas,
            ['idMapel']: this.state.idMapel,
            ['idTematik']: this.state.idTematik,
            ['idKurikulum'] : 3,
            ['linkVideoConf'] : this.state.linkVideoConf,
            ['namaJadwal']: this.state.judulVc,
            ['jadwalMulai']: data.jadwalMulai,
            ['jadwalSelesai']: data.jadwalSelesai,
            ['idKelasParalel']: this.state.selectedKelasParalel,
        }
        console.info('dataSend', dataSend);

        const response = await accountManagement.post(CONFIG.VC_JADWAL_SAVE, dataSend)
        .catch(function(error) {
            console.error(error);
        });

        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                console.info('handleSubmit', response);
            }

            this.setState({
                alertShow: true,
                resMessage: response.data.errorSchema.errorMessage,
                isOpenModalAddEdit: false,
                idProfil: null,
                idJadwal: null,
                jadwal: {},
                judulVc: null,
                tglMulai: '',
                kelasParalel: [],
                selectedKelas: null,
                selectedKelasParalel: [],
                mapel: [],
                idMapel: null,
                idTematik: null,
            })
        }

        this.getListJadwalVidConf();

        this.setState({
            isFetching: false,
        })
    }

    handleDialog = (id, nama) => {
        console.clear();
        console.info('handleDialog', id + ' - ' + nama);

        this.setState({
            openDialog: true,
            selectedProfil: {
                selectedId: id,
                selectedNama: nama
            },
        });
    }
    
    confirmDialog() {        
        const {openDialog, selectedProfil} = this.state;
        const handleClose = () => { this.setState({openDialog: false, selectedProfil: {}}) };
        console.info('confirmDialog', selectedProfil.selectedId + ' - ' + selectedProfil.selectedNama);

        return (
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Konfirmasi Hapus Video Conference ?</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* Menghapus Jadwal Video Conference juga akan menghapus Jadwal<br/> */}
                        Yakin anda akan menghapus Jadwal Video Conference <strong>{selectedProfil.selectedNama}</strong> ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-success" onClick={() => this.handleDelete(selectedProfil.selectedId)} autoFocus> Ya </button>                  
                </DialogActions>
            </Dialog>            
        )
    }

    modalAddEdit() {
        const {jadwal} = this.state;

        if(this.state.isOpenModalAddEdit) {
            return(
                <div className="modal fade show" id="modalLoader" style={{ display: 'block', backgroundColor: 'rgba(91, 140, 184, 0.24)', overflow: 'auto' }} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">{this.state.titleModal}</h5>
                                <span aria-hidden="true"></span>
                            </div>

                            <Form onSubmit={this.handleSubmit}>
                                <div class="modal-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Judul Video Conf</label>
                                                <input className="form-control" placeholder="Judul Video Conference" value={this.state.judulVc} onChange={this.judulOnChange} required/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row" style={{ display: "none" }}>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Link Video Conf</label>
                                                <input className="form-control" name="linkVideoConf" placeholder="URL Video Conference" value={this.state.linkVideoConf} required/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDateTimePicker
                                                    label="Jadwal Mulai"
                                                    name="jadwalMulai"
                                                    value={jadwal.jadwalMulai}
                                                    onChange={this.changeJadwalMulai}
                                                    onError={console.log}
                                                    ampm={false}
                                                    format="dd-MM-yyyy HH:mm" required
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>

                                        <div className="col-md-6">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDateTimePicker 
                                                    label="Jadwal Selesai"
                                                    name="jadwalSelesai"
                                                    value={jadwal.jadwalSelesai}
                                                    onChange={this.changeJadwalSelesai}
                                                    onError={console.log}
                                                    ampm={false}
                                                    format="dd-MM-yyyy HH:mm" required
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Kelas</label>
                                                <select className="form-control" value={this.state.selectedKelas} onChange={this.handleOnChangeKelas} required>
                                                    <option value="" selected disabled>~~ Pilih Kelas ~~</option>
                                                    <DropdownKelasKapital kelas={this.state.kelas} />
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            {!__.isEmpty(this.state.mapel) &&
                                                <div className="form-group">
                                                    <label>Mata Pelajaran</label>
                                                    <select className="form-control" value={this.state.idMapel} onChange={this.handleChangeMapel} required>
                                                        <option value="" selected disabled>~~ Pilih Mapel ~~</option>
                                                        <DropdownMapel mapel={this.state.mapel} />
                                                    </select>
                                                </div>
                                            }
                                            {!__.isEmpty(this.state.tematik) &&
                                                <div className="form-group">
                                                    <label>Tematik</label>
                                                    <select className="form-control" value={this.state.idTematik} onChange={this.handleChangeTematik} required>
                                                        <option value="" selected disabled>~~ Pilih Tematik ~~</option>
                                                        <DropdownTematik tematik={this.state.tematik} />
                                                    </select>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <br></br>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {this.loading()}
                                            {this.renderKp()}
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger pull-left" onClick={(e) => this.modalDismiss()}>Cancel</button>
                                    <button type="submit" class="btn btn-primary pull-right">Save</button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            );
        }
    }

    modalDismiss() {
        this.setState({
            idProfil: null,
            idJadwal: null,
            jadwal: {},
            judulVc: null,
            tglMulai: '',
            kelasParalel: [],
            selectedKelas: null,
            selectedKelasParalel: [],
            mapel: [],
            idMapel: null,
            idTematik: null,
            isOpenModalAddEdit : false
        })
    }

    renderListVidConf() {
        if(!__.isEmpty(this.state.jadwalVidConf)) {
            return this.state.jadwalVidConf.map((vidConf, i) => {
                return (
                    <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{vidConf.namaJadwal}</td>
                        <td>{vidConf.namaMapel}</td>
                        <td>{vidConf.jadwalMulai}</td>
                        <td>{vidConf.jadwalSelesai}</td>
                        <td>
                            <button className="btn btn-primary" onClick={() => this.getDetailJadwalVidConf(vidConf.idJadwal)}>
                                <i className="fa fa-pencil"></i>
                            </button>
                            &nbsp;
                            <button className="btn btn-primary" onClick={() => this.handleDialog(vidConf.idJadwal, vidConf.namaJadwal)}>
                            {/* <button className="btn btn-primary" onClick={() => this.handleDelete(vidConf.idProfil)}> */}
                                <i className="fa fa-trash-o"></i>
                            </button>
                        </td>
                    </tr>
                )
            })
        }
        else {
            return (
                <tr>
                    <td colSpan="6">Tidak Ada Jadwal</td>
                </tr>
            )
        }
    }

    render() {
        console.groupCollapsed('Render Cek State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();
        
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>

                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'Video Conference'}/> 
                    <div className="container-fluid">                         
                        {this.loadAlert()}                        
                        
                        <div className="row">
                            <div className="col-sm-6">    
                                <button className="btn btn-primary" onClick={() => this.setState({ isOpenModalAddEdit : true })}>
                                    <li className="fa fa-plus"> Video <i>Conference</i></li>
                                </button>&nbsp;
                            </div>

                            <div className="col-sm-6">
                                <input type="text" className="form-control pull-right" style={{ width:'60%' }} placeholder="search vc ..."/>
                            </div>
                        </div>
                        <br></br>

                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-striped" id="myTable">
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>Nama Jadwal</th>
                                            <th>Mapel</th>
                                            <th>Jadwal Mulai</th>
                                            <th>Jadwal Selesai</th>
                                            <th>#</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.renderListVidConf()}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {this.loading()}
                        {this.modalAddEdit()}
                        {this.confirmDialog()}
                    </div>
                </div>
            </div>    
        );
    }

    loading = () =>{
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }
    
    loadAlert = () => {
        const {alertShow } = this.state;
      
        if (alertShow) {
            return (
                <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        } 
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Vc); 